import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(255,255,255,0.8);
  min-width: 28%;
  max-width: 90%;
  min-height: 60%;
  border-radius: 0.4rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 1.8rem 2rem;

  box-shadow:
    3.4px 0px 17.2px rgba(0, 0, 0, 0.03),
    8.7px 0px 43.4px rgba(0, 0, 0, 0.019),
    17.7px 0px 88.6px rgba(0, 0, 0, 0.014),
    36.5px 0px 182.5px rgba(0, 0, 0, 0.01),
    100px 0px 500px rgba(0, 0, 0, 0.006);
`;
